import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';

import { UpdateVoiceCommand } from '../types';

type Props = {
  command: UpdateVoiceCommand;
};

export function processUpdateVoiceCommand(props: Props) {
  const result = UpdateVoiceCommand.safeParse(props.command);

  if (!result.success) {
    return;
  }

  const {
    data: { voice_enabled },
  } = result.data;

  if (voice_enabled !== undefined) {
    useStateStore.getState().setTTSEnabled(voice_enabled);
  }
}
